import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import ProfileServices from "./pages/ProfileServices";
import Quote from "./pages/Quote";
import Contact from "./pages/Contact";
import Articles from "./pages/Articles";
import Article from "./pages/Article";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[#040914] text-white">
      <BrowserRouter>
        <CartProvider>
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/:slug" element={<Article />} />
              <Route path="/profil/:id" element={<ProfileServices />} />
              <Route path="/devis" element={<Quote />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: { background: "#0A1326", color: "#fff", border: "1px solid #1E2D4A", borderRadius: 0 },
            }}
          />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
